/**
 * @file redirect-target.ts
 * @description Значение поля «Куда» переадресации (phase19.16, партия Р3в,
 * v0.19.64; SB131, SB128): вид цели, выбранная сущность или адрес строкой;
 * перевод в тело запроса API и из строки списка обратно (окно «Изменить»).
 * Чистые функции — проверяют тесты.
 */

import type { SiteRedirectItem, SiteRedirectTargetInput } from "../api-site-redirects";
import { targetPathProblem, type RedirectTargetKind } from "./redirect-view";

export interface RedirectTargetValue {
  kind: RedirectTargetKind;
  /** Выбранная сущность (у вида «Адрес» — null). */
  id: string | null;
  /** Адрес строкой (у вида «Адрес»). */
  path: string;
}

/** Пустое «Куда»: страница, ничего не выбрано. */
export const EMPTY_REDIRECT_TARGET: RedirectTargetValue = { kind: "SITE_PAGE", id: null, path: "" };

/** Что не так с «Куда»; null — можно отправлять. */
export function redirectTargetProblem(value: RedirectTargetValue): string | null {
  if (value.kind === "PATH") return targetPathProblem(value.path);
  return value.id ? null : "Выберите, куда вести.";
}

/** Тело запроса; незаполненное — null. */
export function redirectTargetInput(value: RedirectTargetValue): SiteRedirectTargetInput | null {
  if (redirectTargetProblem(value)) return null;
  if (value.kind === "PATH") return { targetType: "PATH", targetPath: value.path.trim() };
  return value.id ? { targetType: value.kind, targetId: value.id } : null;
}

/** «Куда» строки списка — для окна «Изменить». */
export function redirectTargetOf(item: Pick<SiteRedirectItem, "target">): RedirectTargetValue {
  const { target } = item;
  if (target.type === "PATH") return { kind: "PATH", id: null, path: target.path ?? "" };
  return { kind: target.type, id: target.id ?? null, path: "" };
}
